// Module
var code = "<wt-fixed-interval-picker data-disabled=\"vm.disabled\" format=\"vm.format\" initial-date=\"vm.initialDate\" interval=\"vm.interval\" prevent-future=\"vm.preventFuture\"> </wt-fixed-interval-picker>";
// Exports
module.exports = code;